import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {MediaCropperPage} from './media-cropper.page';

const routes: Routes = [
	{
		path: '',
		component: MediaCropperPage
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class MediaCropperPageRoutingModule {
}
